import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import DealerCard from "../components/DealerCard";
import { brandConfig } from "config/brandConfig";

export default function Dealers() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Revendeurs certifiés" },
    ]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Liste des revendeurs"
        description={`Découvrez la liste des revendeurs ${brandConfig.brandName} pour toute demande commerciale ou information produit.`}
      />
      <h1>Revendeurs {brandConfig.brandName} – Revendeurs certifiés</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        <DealerCard
          name="1001Coffres"
          location="94340 Cachan"
          website="https://1001coffres.com"
        />
      </div>
      <p className="color-product-desc" style={{ marginTop: 12 }}>
        Vous souhaitez devenir revendeur ? <a href="/contact">Contactez-nous</a>
        .
      </p>
    </>
  );
}
